import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const Container: FC<ComponentProps<"div">> = ({
  className,
  children,
  ...rest
}) => (
  <div
    id="resources-group"
    className={cls("box padded clearfix", className)}
    style={{ scrollMarginTop: "113px" }}
    {...rest}
  >
    {children}
  </div>
);

export default Container;
